<template>
  <ErrorDialogV2
    :value="show"
    @input="$emit('update:show', $event)"
    :title="title"
    confirmButtonText="Got It"
    @confirm="handleClose"
  >
    <div
      v-for="(entry, index) in groupedErrors"
      :key="entry.groupId"
      :class="{ 'pt-4': index > 0 }"
    >
      <Typography variant="body-1" class="text-left black--text pt-4">
        <span class="font-weight-bold">{{ entry.groupName }}</span> is currently in use. Remove it
        from the locations below before deleting.
      </Typography>
      <ul class="program-list pt-2">
        <li v-for="program in entry.programs" :key="`${entry.groupId}-${program.programId}`">
          <Typography variant="body-1" class="text-left black--text">
            Program: {{ program.displayName }}
          </Typography>
        </li>
      </ul>
    </div>
  </ErrorDialogV2>
</template>

<script>
import ErrorDialogV2 from "@/components/ErrorDialogV2.vue";
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "DeleteGroupsErrorDialog",
  components: {
    ErrorDialogV2,
    Typography,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    groupedErrors() {
      const byGroup = new Map();
      for (const error of this.errors) {
        if (!byGroup.has(error.groupId)) {
          byGroup.set(error.groupId, {
            groupId: error.groupId,
            groupName: this.getGroupName(error.groupId),
            programs: [],
          });
        }
        byGroup.get(error.groupId).programs.push({
          programId: error.programId,
          displayName: error.displayName,
        });
      }
      return Array.from(byGroup.values());
    },
    title() {
      return this.groupedErrors.length > 1
        ? "These groups can't be deleted"
        : "This group can't be deleted";
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:show", false);
    },
    getGroupName(groupId) {
      const group = this.groups.find((g) => g.groupId === groupId);
      return group ? group.groupName || group.groupDisplayName : groupId;
    },
  },
};
</script>

<style scoped>
.program-list {
  padding-left: 24px;
}
</style>
